export const getPercentFromDecimal = (decimal: number) => decimal * 100;
